module.exports = {
	extends: [
		'/',
		'templates',
		'artCrm',
		'entity',
		'controller'
	],

	config: {
		usage: 'management',
		entityContext: 'trip',
	}
}